/** @jsxImportSource @emotion/react */
'use memo'

import colors from '@sportninja/common/constants/appColors'

type HeaderBackIconProps = {
  color?: string
}

const HeaderBackIcon = ({ color = colors.NEUTRAL_50 }: HeaderBackIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      aria-hidden='true'
    >
      <path
        d='M11.3679 1.92333C11.0413 1.59666 10.5146 1.59666 10.1879 1.92333L4.58126 7.53C4.32126 7.79 4.32126 8.21 4.58126 8.47L10.1879 14.0767C10.5146 14.4033 11.0413 14.4033 11.3679 14.0767C11.6946 13.75 11.6946 13.2233 11.3679 12.8967L6.47459 8.00333L11.3746 3.10333C11.6946 2.77666 11.6946 2.25 11.3679 1.92333Z'
        fill={color}
      />
    </svg>
  )
}

export default HeaderBackIcon
